import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import GenericTabs from '@mui/material/Tabs';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { MuiTabsProps } from 'src/types/tabs';

export const Tabs = ({
  activeTab,
  handleTabChange,
  tabs,
  isTransform = true,
  noBottomMargin = false,
  scrollable = false,
}: MuiTabsProps) => {
  const theme: any = useTheme();

  return (
    <Box mb={noBottomMargin ? 0 : 2} style={{ minWidth: 0 }}>
      <GenericTabs
        value={activeTab}
        onChange={handleTabChange}
        variant={scrollable ? 'scrollable' : 'standard'}
        scrollButtons={scrollable ? 'auto' : false}
        allowScrollButtonsMobile={scrollable}
        sx={{
          ...(noBottomMargin
            ? {
                minHeight: 40,
                '& .MuiTab-root': {
                  minHeight: 40,
                  py: 1,
                },
              }
            : {}),
          ...(scrollable
            ? {
                '& .MuiTabs-scrollButtons': {
                  color: '#64748B',
                  '&.Mui-disabled': {
                    opacity: 0,
                    width: 0,
                    padding: 0,
                    overflow: 'hidden',
                    pointerEvents: 'none',
                  },
                },
              }
            : {}),
        }}
        TabIndicatorProps={{
          style: {
            backgroundColor: theme?.palette ? theme.palette.primary.main : undefined,
            ...(noBottomMargin ? { bottom: 0 } : {}),
          },
        }}
      >
        {tabs.map((tab) => {
          const label =
            isTransform? tab?.label.charAt(0).toUpperCase() + tab?.label.slice(1).toLowerCase() : tab?.label;

          return (
            <Tab
              key={tab.value ?? label}
              label={label}
              value={tab.value}
              style={{
                padding: noBottomMargin ? '8px 20px' : '0px 20px',
                margin: '0 4px',
                borderRadius: '8px',
                textTransform: 'none',
                minWidth: 'auto',
                color:
                  activeTab === tab.value
                    ? theme.palette.primary.main
                    : theme.palette.text.secondary,
                fontWeight: 600,
                fontSize: '0.75rem',
              }}
            />
          );
        })}
      </GenericTabs>
    </Box>
  );
};

Tabs.propTypes = {
  activeTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleTabChange: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.node,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
};
